<!-- Search and sort -->
<div class="gl-toolbar">
  <app-search-input
    class="gl-search"
    placeholder="Search tags"
    [debounce]="350"
    (valueChange)="updateSearchTerm($event)"
  />

  <app-sort-dropdown
    [groups]="sortGroups"
    [selectedValue]="sortCriteria"
    (selectionChange)="updateSortCriteria($any($event))"
  />

  <span class="gl-toolbar__spacer"></span>

  <p class="gl-count" aria-live="polite">{{ countLine }}</p>
</div>

<!-- Selection bar: what to do with the ticked tags -->
@if (selectedTags.length) {
  <div class="gl-select" role="region" aria-label="Selected tags">
    <span class="gl-select__count">{{ selectionLabel }}</span>
    <span class="gl-select__actions">
      <button
        *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
        type="button"
        class="gl-select__btn"
        (click)="handleAction('send-sms')"
      >
        <span class="bk-sym" aria-hidden="true">send</span>
        Message
      </button>
      <button
        *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
        type="button"
        class="gl-select__btn"
        (click)="handleAction('delete')"
      >
        <span class="bk-sym" aria-hidden="true">delete</span>
        Delete
      </button>
    </span>
    <button type="button" class="gl-select__clear" (click)="resetSelectedTags()">Clear selection</button>
  </div>
}

<tags-table
  class="gl-table"
  [params]="reactiveParams"
  [searchTerm]="searchTerm"
  (getSelections)="updateSelectedTags($event)"
  (totalChange)="updateTotal($event)"
  (clearFilters)="clearSearch()"
/>

<!-- MODALS -->
<app-prompt-card
  [title]="deleteTitle"
  [buttonText]="deleteButton"
  tone="danger"
  impact="This cannot be undone."
  impactIcon="warning"
  [openModal]="showDeleteSelectedTagsPrompt"
  (onClose)="closeDeleteSelectedTagsPrompt()"
  (onButtonClick)="deleteSelectedTags()"
  [loading]="deleting"
>
  <p class="gl-prompt">{{ deleteImpact }}</p>
</app-prompt-card>
